import { render, staticRenderFns } from "./ErrorView.vue?vue&type=template&id=60251d6c&scoped=true&"
import script from "./ErrorView.vue?vue&type=script&lang=ts&"
export * from "./ErrorView.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorView.vue?vue&type=style&index=0&id=60251d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60251d6c",
  null
  
)

export default component.exports